export default "__VITE_PUBLIC_ASSET__899c1d50__"